import script from "./LanguageSelectionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectionEditor.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectionEditor.vue?vue&type=style&index=0&id=68efd5fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68efd5fd"]])

export default __exports__